import { DATA_OPERATION } from 'store/enums';

import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  guidToCancel: null,
  guidToCancelB2C: null,
  customerType: DATA_OPERATION.CUSTOMER_TYPE.PARTICULAR,
  flux: DATA_OPERATION.FLUX.STRATOS,
  prospect: {
    contact: [
      {
        contactType: DATA_OPERATION.CONTACT_TYPE.CONTACT,
        documentType: 0,
        documentId: '',
        name: '',
        lastname: '',
        lastname2: '',
        genre: '',
        maritalStatus: null,
        jobType: null,
        address: {
          streetType: '',
          address1: '',
          postalCode: '',
          provinceCode: '',
          cityCode: ''
        },
        email: '',
        phone: '',
        mobile: '',
        chkRobinson: false,
        chkTermsAndConditions: true,
        chkDataTransfer: false,
        chkProactive: false,
        birthDate: '',
        signType: '',
        driverLicenseIssuedDate: '',
        insuranceType: '',
        insuranceMonthFee: '',
        operationOwner: '',
        marketPlaceOrderId: ''
      }
    ]
  },
  companyData: {
    name: '',
    documentId: '',
    constitutionDate: '',
    address: {
      streetType: '',
      address1: '',
      postalCode: '',
      provinceCode: '',
      cityCode: ''
    },
    phone: '',
    email: '',
    fax: ''
  },
  prospectB2B: {
    contact: [
      {
        cif: '',
        email: '',
        businessName: ''
      }
    ],
    chkPartnerConfirmation: false
  },
  renovationPlate: '',
  chkPartnerConfirmation: false,
  user: '',
  quoteId: 0,
  partnerId: 0,
  idC: null,
  contactId: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
